export const colum = [
    {
        label: "STT",
        key: "stt",
        align: 'center',
        width: '5%'
    },
    {
        label: "Hình ảnh",
        key: "image",
        align: 'center',
    },
    {
        label: "Tên nhân viên",
        key: "name_employee",
        align: 'left',
        // width: '0%'
    },
    {
        label: "Phòng ban",
        key: "department",
        align: 'left',
        width: '15%'
    },
    {
        label: localStorage?.getItem("role")?.split(",")?.some(r => r === "A") ? "Đơn vị" : "",
        key: localStorage?.getItem("role")?.split(",")?.some(r => r === "A") ? "organization_name" : '',
        align: 'left',
        width: '15%'
    },
    {
        label: "Thời gian nhận dạng",
        key: "time_detect",
        align: 'center'
    },
    {
        label: "Hành động",
        key: "action",
        align: 'center',
    },
];